import api from 'api'
import { CategoriesAPI } from './types'

interface Params {
  search?: string
}

const categoriesWithoutCourses = ({ search = '' }: Params = {}) => {
  return api
    .get<CategoriesAPI>('/courses/categories', {
      params: {
        search,
        origin: 'library',
        no_courses: true,
      },
    })
    .then(({ data }) => data)
}

export default categoriesWithoutCourses
